'use strict';

namespace Core {

    class FlightStops {

        stops: string;

        public getStops() {
            return this.stops === '' ? undefined : new Array(parseInt(this.stops, 10));
        }
    }

    angular
        .module('core')
        .directive('flightStops', (): ng.IDirective => {

            return {
                scope: {},
                restrict: 'E',
                replace: true,
                bindToController: {
                    stops: '@'
                },
                controller: FlightStops,
                controllerAs: 'fs',
                template:   '<div class="flight-stops-graphic">' +
                            '   <div class="stops">' +
                            '       <div class="stop" ng-repeat="stop in fs.getStops() track by $index"></div>' +
                            '   </div>' +
                            '</div>'

            };

        });
}
